import { QuoteTemplateFieldError } from '../quotetemplate';
import { IQuoteTemplateFieldErrorData } from '../quotetemplate.types';

export const mockQuoteTemplateFieldErrorData: IQuoteTemplateFieldErrorData = {
  title: ['Ensure this field has no more than 64 characters.'],
  description: ['Ensure this field has no more than 64 characters.']
};

export const mockQuoteTemplateFieldError = new QuoteTemplateFieldError(
  mockQuoteTemplateFieldErrorData
);
